import config from "../../../config";

// This used to wrap Rollbar, but rollbar has been removed.
//
// It's now been simplified down to the only non-rollbar action:
// printing the error to console if we're in dev mode.
const serverError = function (err, req, payload) {
  if (config("environment") === "development") {
    // eslint-disable-next-line no-console
    console.error(err, payload);
  }
};

const clientError = serverError;

export { serverError, clientError };
